export class Controller {

    /** @ngInject */
    constructor($state, Alert, GroupsResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.groupName = '';
    }

    save() {
        this.isSaving = true;
        this.GroupsResource
            .createNewCustomGroup(this.companyId, this.groupName)
            .then(({id}) => this.$state.go('company.user-directories.manage-group', {groupId: id}))
            .then(() => this.Alert('success', 'company.user-directories.directory-groups.directory.add-new-group.added'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/add-new-group/add-new-group.controller.js